import axios from "axios";
import { configUrl } from "config";

export const addBulkPdfQuestions = async (payload) => {
    try {
        const response = await axios.post(
            `${configUrl?.AssessmentServer}/api/Questions/addBulkPdfQuestions`,
            payload
        );

        return response.data;
    } catch (error) {
        console.error("Error adding bulk PDF questions:", error);
        throw error;
    }
};